import { isValid, parse } from 'date-fns';
import {
  IWeddingEvent,
  IWeddingEvent2,
} from '@bridebook/models/source/models/Weddings/Events.types';
import {
  DATE_FORMAT,
  format,
  formatTimeByLocale,
  parseIsoOnlyDate,
} from '@bridebook/web/lib/time-date-manipulation/time-date-manipulation';

interface FormatEventDateOptions {
  withEndTime?: boolean;
}

export const formatEventDateAndTime = (
  date: string,
  time: IWeddingEvent2['time'],
  locale: string,
  options?: FormatEventDateOptions,
) => {
  if (!date) return '';
  const start = time?.startTime;
  const end = time?.endTime;

  const dateString = format(
    parseIsoOnlyDate(date),
    DATE_FORMAT.DATE.WITH_SHORT_DAY_SHORT_MONTH_YEAR,
  );
  const startTimeString = start ? formatEventTime(start, locale) : '';
  const endTimeString = end ? formatEventTime(end, locale) : '';

  if (startTimeString && endTimeString && options?.withEndTime) {
    return `${startTimeString} - ${endTimeString}, ${dateString}`;
  }

  if (startTimeString) {
    return `${startTimeString}, ${dateString}`;
  }

  return dateString;
};

// Stored "HH:mm" shown in the market's clock convention; a fixed reference day avoids DST gaps.
export const formatEventTime = (timeString: string, locale: string) => {
  const parsedTime = parse(timeString, 'HH:mm', new Date(2000, 0, 1));
  if (!parsedTime || !isValid(parsedTime)) return '';
  return formatTimeByLocale(parsedTime, locale);
};

export const formatEventTimeRange = (
  time: IWeddingEvent['time'],
  locale: string,
  suffix: string = '',
) => {
  const start = time?.startTime;
  const end = time?.endTime;

  if (start && end) {
    return `${formatEventTime(start, locale)} - ${formatEventTime(end, locale)}${suffix}`;
  }

  if (start) {
    return `${formatEventTime(start, locale)}${suffix}`;
  }

  return '';
};

export const formatEventDate = (dateString: string, shouldUseOrdinals: boolean) => {
  const parsedDate = parseIsoOnlyDate(dateString);
  if (!parsedDate || !isValid(parsedDate)) return '';
  const formattedDate = format(
    parsedDate,
    shouldUseOrdinals ? DATE_FORMAT.DATE.CALENDAR.LONG : DATE_FORMAT.DATE.LONG,
  );
  return formattedDate;
};
